export * from './resolves.resolver';



// WEBPACK FOOTER //
// ./src/app/resolves/index.ts